import CityPageTemplate from "../city-template/CityPageTemplate";
import { thousandOaksConfig } from "./data";

export default function ThousandOaksPage() {
  return <CityPageTemplate config={thousandOaksConfig} />;
}